// import { render } from "@react-email/render";
// import sendgrid from "@sendgrid/mail";
// import OnboardingEmailTemplate from "./components/onboardingEmails/OnboardingEmailTemplate";
import React, { useState } from "react";

import "./App.scss";

import SendOnboardingEmailsForm from "./components/onboardingEmails/SendOnboardingEmailsForm";
import HeaderNavbar from "./components/navbars/HeadeNav";
import { Button } from "react-bootstrap";
import SinglePageHeader from "./components/pageHeaders/singlePageHeader";

function App() {
  const [messageSent, setMessageSent] = useState(false);

  async function sendOnboardingEmailHandler(onboardingMailValues) {
    const response = await fetch("https://eoek8xfhaw1bse3.m.pipedream.net", {
      method: "POST",
      body: JSON.stringify(onboardingMailValues),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response;

    // console.log(data);
    if (data.status === 200) {
      // console.log("Message sent");
      setMessageSent(true);
    } else {
      setMessageSent(false);
    }
  }

  return (
    <div className="App">
      <HeaderNavbar />
      <SinglePageHeader />
      {!messageSent ? <SendOnboardingEmailsForm onSendOnboardingEmail={sendOnboardingEmailHandler} /> : "Message sent. Thank you."}
      {messageSent && (
        <p className="mt-3">
          <Button variant="primary" className="ml-3" href="/">
            Reload
          </Button>
        </p>
      )}
    </div>
  );
}

export default App;
